import React, { useState, useEffect } from "react";
import { Grid } from "grommet";
import moment from "moment";
import {withRouter} from 'react-router-dom'
import { API,Auth } from 'aws-amplify';
import {WhichUrl} from './utils/shared/shipmentViewFunctions'
import ShipmentTableView from "./ShipmentTableView";

function ListShipments(props) {
  const [dataLoaded, setDataLoaded] = useState(false);
  const [shipments, setShipments] = useState("");
  const [awbNumber, setAwbNumber] = useState("");
  const [inTransit, setInTransit] = useState(0);
  const [awaitingPickup, setAwaitingPickup] = useState(0);
  const [exception, setException] = useState(0);
  const [dateRange, setDateRange] = useState([moment().subtract(1, 'months').date(1).format(),moment().format()])
  function fetchShipments(params){
    const apiUrl = WhichUrl(params, props.user)
    Auth.currentSession().then(session => {
      API
        .get("LabShip", apiUrl,{headers: { 
          Authorization: session.idToken.jwtToken,
        }})
        .then(
          (result) => {
            setInTransit(result.shipments_in_transit)
            setAwaitingPickup(result.shipments_awaiting_pickup)
            setException(result.shipments_exception)
            setShipments(result.shipments);
            setDataLoaded(true);
          },
          (error) => {
            console.log(error);
          }
        );
    })
  }
  useEffect(() => {
   fetchShipments(null)
  }, []);



  function filterShipments(){
      setDataLoaded(false)
      fetchShipments(dateRange)   
  }

  function queryShipmentsStatus(status){
    setDataLoaded(false)
    fetchShipments(status)
  }

  function queryShipments(){
    if (awbNumber.length > 0){
      setDataLoaded(false)
      fetchShipments(awbNumber)
    }   
}
function reloadShipments(){
  setDataLoaded(false)
  fetchShipments(null)    
}
  
const onChange = (event) => {
  const nextValue = event.value;
  setDateRange(nextValue);
};
  return (
    <Grid>
      <ShipmentTableView queryShipmentsStatus={queryShipmentsStatus}  inTransit={inTransit} exception={exception} awaitingPickup={awaitingPickup} displayQuote={props.displayQuote} dateRange={dateRange} onChange={onChange} dataLoaded={dataLoaded} reloadShipments={reloadShipments} queryShipments={queryShipments} filterShipments={filterShipments} awbNumber={awbNumber} setAwbNumber={setAwbNumber} props={props} shipments={shipments} />
    </Grid>
  )
              
}

export default withRouter(ListShipments);
